export default "__VITE_ASSET__d7f300bf__"